import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { App } from "@/App";
import { initSentry } from "@/lib/sentry";
import { isNativeApp } from "@/utils/platform";
import "@/styles/globals.css";

// s63 (S-3 #2): SOLO en el wrapper nativo endurecemos el viewport para
// matar el zoom inicial en frío del WKWebView (maximum-scale +
// user-scalable=no). El navegador web NO pasa por aquí → el pinch-zoom
// normal queda intacto (restricción explícita del spec).
if (isNativeApp()) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      "content",
      "width=device-width, initial-scale=1.0, viewport-fit=cover, "
        + "maximum-scale=1.0, user-scalable=no",
    );
}

// Sprint 7 B4: Sentry SOLO se activa en builds de producción
// (import.meta.env.PROD). En dev/test el SDK queda completamente
// inactivo — sin tráfico, sin cupo gastado. Llamada antes de
// `createRoot` para que el hook capture errores sincrónicos del
// bootstrap React.
initSentry();

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root no encontrado en index.html.");
}

const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID;

// Si VITE_GOOGLE_OAUTH_CLIENT_ID no está set (típico en dev local sin Google
// configurado), saltamos GoogleOAuthProvider — el botón "Continuar con Google"
// detecta la ausencia y se oculta. El resto del auth (email/password, reset)
// sigue funcionando.
const tree = GOOGLE_CLIENT_ID ? (
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
) : (
  <App />
);

createRoot(container).render(<StrictMode>{tree}</StrictMode>);
